/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Zestard update the style of the gift wrap
  document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.product-bundle-template')) return;

    const observer = new MutationObserver(function() {
      const textarea = document.querySelector('.zt_message_note textarea');
      const price = document.querySelector('.giftwrap-price');

      if (textarea && price) {
        textarea.setAttribute('placeholder', 'Personalise by adding your name');
        textarea.setAttribute('maxlength', '20');
        const amount = price.textContent.trim().replace(/[^0-9.]/g, '');
        price.textContent = '£' + parseFloat(amount).toFixed(2);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
  
  // Zestard move button above ATC button
  document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.product-bundle-template')) return;

    const observer = new MutationObserver(function() {
      const zestardWidget = document.querySelector('.show_frontend');
      const submitButtons = document.querySelector('.product__submit__buttons');

      if (zestardWidget && submitButtons) {
        submitButtons.parentNode.insertBefore(zestardWidget, submitButtons);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
